(function($, window, document) { // jQuery wrapper

    // Page Functions
    window.PageFunctions = {

        menu: "",
        menuToggle: "",

        // Smooth scroll on page anchor links.
        // Will scroll to the top for # links.
        smoothScroll : function (){
            $('a[href^="#"]').click(function () {
                var scrollTarget;
                // If the link is just # set scrollTarget to top of page
                if($(this).attr('href') === '#'){
                    scrollTarget = 0;
                }else{ // Otherwise locate the target element and find its offset from the top
                    if (location.pathname.replace(/^\//, '') === this.pathname.replace(/^\//, '') && location.hostname === this.hostname) {
                        var target = $(this.hash);
                        target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
                        if (target.length) {
                            scrollTarget =  target.offset().top;
                        }
                    }
                }
                // Scroll the page to the target.
                $('html, body').animate({
                    scrollTop: scrollTarget
                }, 1000);
                return false; // Exit.
            });
        },

        newsletterPopup : function (){
            //$('.j-newsletter--toggle').on('click',function(){
            //    var newsletter = $(this).parents('.j-newsletter');
            //    var body = $('body');
            //    body.toggleClass('no-scroll');
            //    body.toggleClass('cover-up');
            //    $('.o-header').toggleClass('o-header__light-temp');
            //    newsletter.find('.j-newsletter--overlay').fadeToggle();
            //
            //    $('html, body').animate({
            //        scrollTop: scrollTarget
            //    }, 1000);
            //});
        },
        renderMap : function(){
            $('.j-map').each(function(){
                render_map( $(this) );
            });
        }
    };



        /*
         *  render_map
         *
         *  This function will render a Google Map onto the selected jQuery element
         *
         *  @type function
         *  @date 8/11/2013
         *  @since 4.3.0
         *
         *  @param $el (jQuery element)
         *  @return n/a
         */

        function render_map( $el ) {

            // var
            var $markers = $el.find('.marker');

            // vars
            var args = {
                zoom : $el.data('zoom'),
                center : new google.maps.LatLng(0, 0),
                mapTypeId : google.maps.MapTypeId.ROADMAP,
                styles: JSON.parse(map_style)
            };

            // create map
            var map = new google.maps.Map( $el[0], args);

            // add a markers reference
            map.markers = [];

            // add markers
            $markers.each(function(){
                add_marker( $(this), map );
            });

            // center map
            center_map( map, $el );

        }

        /*
         *  add_marker
         *
         *  This function will add a marker to the selected Google Map
         *
         *  @type function
         *  @date 8/11/2013
         *  @since 4.3.0
         *
         *  @param $marker (jQuery element)
         *  @param map (Google Map object)
         *  @return n/a
         */

        function add_marker( $marker, map ) {

            // var
            var latlng = new google.maps.LatLng( $marker.attr('data-lat'), $marker.attr('data-lng') );

            // create marker
            var marker = new google.maps.Marker({
                position : latlng,
                map : map,
                icon: $marker.attr('data-pin')
            });

            // add to array
            map.markers.push( marker );

            // if marker contains HTML, add it to an infoWindow
            if( $marker.html() )
            {
                // create info window
                var infowindow = new google.maps.InfoWindow({
                    content : $marker.html()
                });

                // show info window when marker is clicked
                google.maps.event.addListener(marker, 'click', function() {

                    infowindow.open( map, marker );

                });
            }

        }

        /*
         *  center_map
         *
         *  This function will center the map, showing all markers attached to this map
         *
         *  @type function
         *  @date 8/11/2013
         *  @since 4.3.0
         *
         *  @param map (Google Map object)
         *  @return n/a
         */

        function center_map( map , $el) {

            // vars
            var bounds = new google.maps.LatLngBounds();

            // loop through all markers and create bounds
            $.each( map.markers, function( i, marker ){

                var latlng = new google.maps.LatLng( marker.position.lat(), marker.position.lng() );

                bounds.extend( latlng );

            });

            // only 1 marker?
            if( map.markers.length == 1 )
            {
                // set center of map
                map.setCenter( bounds.getCenter() );
                map.setZoom( $el.data('zoom') );
            }
            else
            {
                // fit to bounds
                map.fitBounds( bounds );
            }

        }



}(window.jQuery, window, document)); // End of jQuery wrapper

